import React from 'react'
import "./FirstSection.css"
import { Col, Container, Row } from 'react-bootstrap'
// import img1 from "../../Assets/images/Vector1.png"
import img2 from "../../Assets/images/Frame17.png"
import { LiaCheckCircleSolid } from "react-icons/lia";
import { useTranslation } from 'react-i18next'
import img1 from "../../Assets/images/home1.png"

function FirstSection() {
  const { t } = useTranslation();

  return (
    <div className='pt-2'>
      <img src={img1} alt='' className='first-img w-100' />
    </div>
  )
}

export default FirstSection
